import { FC } from 'react';
import InputAdornment from '@mui/material/InputAdornment';
import TextField, { TextFieldProps } from '@mui/material/TextField';

type Props = TextFieldProps;

const PercentInput: FC<Props> = props => (
  <TextField
    {...props}
    InputProps={{
      endAdornment: <InputAdornment position="start">%</InputAdornment>,
    }}
  />
);

export default PercentInput;
